<template>
<div>
	<hearderCommon :text="textT"></hearderCommon>
	<div class="main">
		<div class="title">
			<div class="title_pic">
				<img :src="list.picUrl" alt="" class="pic">
			</div>
			<div class="title_text">
				<div>{{list.name}}</div>
				<div class="area">产地：{{list.originName}}</div>
			</div>
		</div>
		<div class="content">
				<i class="i"></i>
				<span class="content_title" >采购环节</span>
			<div class="content_minititle">采购批次号</div>
			<div>{{list.subscribeCode}}</div>
			<div class="content_minititle">供应商名称</div>
			<div>{{list.supplierName}}</div>	
			<div class="content_minititle" >营业执照</div>
			<div>
				<img v-if="list.businessLicense" :src="list.businessLicense" alt="" class="pic_sale" @click="showPopup">
				<van-icon name="expand-o" />
				<img v-if="list.foodBusinessLicense" :src="list.foodBusinessLicense" alt="" class="pic_sale" @click="showPopup">
				<van-icon name="expand-o" />
				<img v-if="list.foodCirculationLicense" :src="list.foodCirculationLicense" alt="" class="pic_sale" @click="showPopup">
				<van-icon  name="expand-o" />
				<van-popup v-model="show">
						<img :src="picurl" alt="" class='large_pic'>
				</van-popup>
			</div>
		</div>
		<div class="content">
			<i class="i"></i>
			<span class="content_title">出库环节</span>
			<div class="content_minititle">出库时间</div>
			<div>{{list.wmsOutTime ? list.wmsOutTime : '-'}}</div>
			<div class="content_minititle">出库地址</div>
			<div>{{list.wmsOutAddress ? list.wmsOutAddress : '-'}}</div>
			<div class="content_minititle">分拣人</div>
			<div>{{list.weighName ? list.weighName : '-'}}</div>
		</div>
		<div class="content">
			<i class="i"></i>
			<span class="content_title">配送环节</span>
			<div class="content_minititle">配送时间</div>
			<div>{{list.deliveryTime ? list.deliveryTime : '-'}}</div>
			<div class="content_minititle">配送人</div>
			<div>{{list.userName ? list.userName : '-'}}</div>
			<div class="content_minititle">配送人联系电话</div>
			<div>{{list.mobile ? list.mobile : '-'}}</div>	
		</div>
	</div>
</div>
</template>


<script>
import hearderCommon from "../common/headerCommon";
export default {
	components: {
    hearderCommon
  },
 data() {
	return {
		list:{},
		show:false,
		picurl:'',
		textT: "品质溯源",

	}
 },
 created() {
	this.query()
 },
 methods: {
	async query() {
		const res = await  this.$axios.post(
			'/trade/tradeOrder/qualitySource',
			{
				goodsId:this.$route.query.goodsId,
				orderId:this.$route.query.orderId,
				orderDtlId:this.$route.query.orderDtlId
			}
		)
		this.list = res.data.data
		if (this.list.wmsOutTime) {
			this.list.wmsOutTime = this.$moment(this.list.wmsOutTime)
					.add("day")
					.format("YYYY-MM-DD HH:mm:ss");
		}
		if (this.list.deliveryTime) {
			this.list.deliveryTime=this.$moment(this.list.deliveryTime).add("day").format("YYYY-MM-DD HH:mm:ss");
		}
	},
	showPopup(e) {
		this.picurl = e.target.currentSrc
		this.show = true;
	},
 },
}
</script>

<style scoped>
.title {
	background-color: rgb(255, 255, 255);
	padding: 20px 10px;
	display:flex;
	justify-content:space-between;
}
.title_pic {
	width: 100px;
	height:80px;
	background-color:#000;
}
.title_text {
	font-size: 14px;
	padding-left: 10px;
	width: 100%;
	text-align: left;
}
.area {
	margin-top: 25px;
	color: #A5A5A5;
	font-size:12px
}
.content {
	background-color: rgb(255, 255, 255);
	padding: 20px 10px;
	margin-top:10px
}
.content_title {
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  text-align: left;
  line-height: 20px;
	margin-bottom:20px
}
.content_minititle {
	color: rgba(165, 165, 165, 1);
	font-size: 12px;
	margin-bottom: 10px;
	margin-top: 10px;
}
.pic {
	width:100%;
	height:100%;
	/* width: 80px; */
	/* height:80px; */
}
.pic_sale {
	width: 100px;
	height:80px;
	margin-right: 10px;
}
/* .group {
	background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng017c81e1937aa8dae7b3eb98c8cdc7c3b1e781930393b5c8486410a21a578c35)
    100% no-repeat;
	width: 18px;
  height: 18px;
	background-size: 100% 100%;
  margin: 37px 0 0 60px;

} */
.van-icon-expand-o:before {
		color: #aca59c;
		border-radius:60% ;
		position: absolute;
    top: -16px;
    left: -26px;
}
.i {
	border: 1px solid #74b42b;
	margin-right: 5px;
}
.large_pic {
	width: 100%;
	height: 100%;
}

.van-popup--center {
	padding-bottom:0px;
	/* box-sizing: border-box; */
	/* width: 50vh; */
	/* height: 50vh; */
}
.main {
	padding-top:40px;
}
</style>